import React from 'react';
import { Link } from 'react-router-dom';
import { GlassCard } from '@/components/GlassCard';
import { Logo } from '@/components/Logo';
import { Button } from '@/components/ui/button';
import { XCircle } from 'lucide-react';
import { Seo } from '@/components/Seo';

export default function PaymentCancelPage() {
  return (
    <div className="relative min-h-screen th-hero-radial">
      <Seo title="Payment Cancelled | Thirrsty.com" path="/payment/cancel" noindex />
      <div className="mx-auto flex min-h-screen max-w-md flex-col px-6 py-10">
        <div className="mb-6"><Logo /></div>
        <GlassCard className="p-6 text-center th-float-in" data-testid="payment-cancel-card">
          <div className="py-6">
            <div className="mx-auto grid h-14 w-14 place-items-center rounded-full bg-white/10 text-white/70">
              <XCircle className="h-8 w-8" />
            </div>
            <h1 className="mt-4 font-display text-2xl font-semibold" style={{ fontFamily: 'Space Grotesk' }}>Payment cancelled</h1>
            <p className="mt-2 text-sm text-white/70">No charge was made. You can try again anytime — or pay via Zelle instead.</p>
            <Button asChild className="mt-6 h-11 w-full rounded-xl bg-[#F6B24A] text-[#1A1208] hover:bg-[#FFC065] font-semibold" data-testid="payment-cancel-back">
              <Link to="/profile/subscription">Back to my subscription</Link>
            </Button>
          </div>
        </GlassCard>
      </div>
    </div>
  );
}
